import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

export const retrieveDonationSettings = async () => {
  const { body } = await api.get<DonationSettingsResponse>(
    "/donation-settings/"
  )
  return body
}

export const useDonationSettings = () =>
  useQuery({
    queryKey: [BASE_DONATION_SETTINGS_QUERY_KEY],
    queryFn: () => retrieveDonationSettings(),
    staleTime: 60 * 60 * 1000,
  })
